import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EditService} from '../shared/services/editService/edit.service';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {EmailTable} from '../shared/classes/EmailTable';
import {faChevronDown, faChevronRight} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css']
})
export class MailComponent implements OnInit {


  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private emailTableService: EmailTableService,
              private formBuilder: FormBuilder,
              private racesService: RacesService,
              private editService: EditService) { }

  private static NEW_ID = 'new';

  key_name = '{field:jmeno}';
  key_surname = '{field:prijmeni}';
  key_year = '{field:roknarozeni}';
  key_club = '{field:klub}';
  key_startFee = '{field:startovne}';
  key_varSym = '{field:varSym}';
  key_account = '{field:ucet}';
  key_note = '{field:poznamka}';
  key_mobile = '{field:telefon}';
  key_email = '{field:email}';
  key_city = '{field:mesto}';
  key_custNote = '{field:pozn}';
  id = undefined;
  raceId;

  right = faChevronRight;
  down = faChevronDown;
  showKeyWords = false;

  emailForm = this.formBuilder.group({
    onRegFrom: ['', [Validators.email]],
    onRegSubject: ['', []],
    onRegMessage: ['', []],
    onPayFrom: ['', [Validators.email]],
    onPaySubject: ['', []],
    onPayMessage: ['', []],
    onCashFrom: ['', [Validators.email]],
    onCashSubject: ['', []],
    onCashMessage: ['', []],
  });

  isNew = false;
  plusButton = false;
  editButton = true;
  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';
  emailTable: EmailTable = new EmailTable();
  emails: EmailTable[] = undefined;

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isNew = this.id === MailComponent.NEW_ID;
    this.raceId = this.isNew ? undefined : this.id;
    this.racesService.raceId = this.id;
    this.loadMessage();
  }

  loadMessage() {
    this.emails = [];
    this.emailTableService.getOne(this.id).then((data) => {
        this.emails = data.data().emails;
        this.emailTable.id = data.id;

        this.emails.forEach(email => {
          switch (email.messageType) {
            case EmailTable.ON_REG: {
              this.emailForm.patchValue({
                onRegFrom: email.onRegFrom,
                onRegSubject: email.onRegSubject,
                onRegMessage: email.onRegMessage
              });
              break;
            }
            case EmailTable.ON_PAY: {
              this.emailForm.patchValue({
                onPayFrom: email.onPayFrom,
                onPaySubject: email.onPaySubject,
                onPayMessage: email.onPayMessage
              });
              break;
            }
            case EmailTable.ON_CASH: {
              this.emailForm.patchValue({
                onCashFrom: email.onCashFrom,
                onCashSubject: email.onCashSubject,
                onCashMessage: email.onCashMessage
              });
              break;
            }
            default: {
              console.error('errr');
            }
          }
        });
    });
  }

  save(item) {
    this.emails = [];
    const onRegEmail: EmailTable = new EmailTable();
    onRegEmail.onRegFrom = this.emailForm.value.onRegFrom;
    onRegEmail.onRegSubject = this.emailForm.value.onRegSubject;
    onRegEmail.messageType = EmailTable.ON_REG;
    onRegEmail.onRegMessage = this.emailForm.value.onRegMessage;
    this.emails.push(onRegEmail);

    const onPayEmail: EmailTable = new EmailTable();
    onPayEmail.onPayFrom = this.emailForm.value.onPayFrom;
    onPayEmail.onPaySubject = this.emailForm.value.onPaySubject;
    onPayEmail.messageType = EmailTable.ON_PAY;
    onPayEmail.onPayMessage = this.emailForm.value.onPayMessage;
    this.emails.push(onPayEmail);

    const onCashEmail: EmailTable = new EmailTable();
    onCashEmail.onCashFrom = this.emailForm.value.onCashFrom;
    onCashEmail.onCashSubject = this.emailForm.value.onCashSubject;
    onCashEmail.messageType = EmailTable.ON_CASH;
    onCashEmail.onCashMessage = this.emailForm.value.onCashMessage;
    this.emails.push(onCashEmail);

    console.dir(this.emails);

    this.emailTableService.save(this.id, this.emails).then(() => {
    }).catch((err) => {
      console.log(err);
    });
  }

  delete(item) {

  }

  edit(item) {

  }

  add(item) {

  }

  toggleKeyWords() {
    this.showKeyWords = !this.showKeyWords;
  }

}
